class CommonContants {
  static NUXEO_DATE_FORMAT = "MMMM DD, YYYY";

  static FILTER_FIRST_PAGE = 0;
  static FILTER_MIN_PAGE_SIZE = 1;
  static FILTER_MAX_PAGE_SIZE = 96;
  static FILTER_DEFAULT_PAGE_SIZE = 96;

  static FILE_VIEWS_THUMBNAIL = 0;
  static FILE_VIEWS_THUMBNAIL_TEXT = "Thumbnail";
  static FILE_VIEWS_SMALL = 1;
  static FILE_VIEWS_SMALL_TEXT = "Small";
  static FILE_VIEWS_MEDIUM = 2;
  static FILE_VIEWS_MEDIUM_TEXT = "Medium";
  static FILE_VIEWS_LARGE = 3;
  static FILE_VIEWS_LARGE_TEXT = "Full HD";
  static FILE_VIEWS_ORIGINAL = 4;
  static FILE_VIEWS_ORIGINAL_TEXT = "Original";

  static ARCHIVE_ASSETS_FILE_TYPE = "FileArchive";
  static ACTIVE_ASSETS_FILE_TYPE = "liveFile";
  static MIXED_ASSETS_FILE_TYPE = "MixedFile";
}

export default CommonContants;
